import React, { useState } from 'react';
import { Upload } from 'antd';
import { useIntl } from 'react-intl';

import { openModal } from 'utils/modal';

import CroppingModal from './CroppingModal/CroppingModal';

import { ReactComponent as UploadIcon } from 'assets/bosta-icons/avatar-upload.svg';
import { ReactComponent as Plus } from 'assets/imgRevamp/plus.svg';

import './AvatarUpload.less';

const AvatarUpload = ({ value = [], onChange }) => {
  const intl = useIntl();
  const [loading, setLoading] = useState(false);

  const setCroppedImage = async (blob, file) => {
    const uid = `rc-upload-${Date.now()}`;
    const croppedFile = new File([blob], file.name, { type: file.type });

    const fileObj = {
      uid,
      name: file.name,
      status: 'done',
      originFileObj: croppedFile,
      url: URL.createObjectURL(blob)
    };

    onChange?.([fileObj]);
  };

  const beforeUpload = (file) => {
    const reader = new FileReader();

    reader.onload = (e) => {
      const img = e.target.result;

      openModal(CroppingModal, {
        loading,
        setLoading,
        imageUrl: img,
        setCroppedImage,
        file
      });
    };
    reader.readAsDataURL(file);
    return false;
  };

  return (
    <div className="br-avatar-upload__container">
      <Upload
        showUploadList={false}
        beforeUpload={beforeUpload}
        accept="image/*"
      >
        {!value?.length ? (
          <div className="br-avatar-uplaod__upload-button">
            <UploadIcon />
            <span className="label_sm">
              {intl.formatMessage({ id: 'avatar_upload.upload' })}
            </span>
          </div>
        ) : (
          <div className="br-avatar-upload__upload-image-wrapper">
            <img
              src={value[0]?.url || value}
              alt="Cropped Avatar"
              className="br-avatar-uplaod__upload-button"
            />
            <Plus />
          </div>
        )}
      </Upload>
    </div>
  );
};

export default AvatarUpload;
